import React from "react";
import Navbar from "../../components/Navbar/Navbar";

const NPPAcademy = () => {
    return (
        <div className="main-container">
                <Navbar />
        </div>
    )
}
export default NPPAcademy;